import {
  type LazyResponse,
  useApolloRequestLazyWrapper,
} from '../../../api/useApolloRequestLazyWrapper'
import {
  type GetRetailerProductDetailsQuery,
  type GetRetailerProductDetailsQueryVariables,
  useGetRetailerProductDetailsLazyQuery,
} from '../../../../api'
import { type RetailerProductDetailsResponse } from './types'

function mapResponse(data: GetRetailerProductDetailsQuery): RetailerProductDetailsResponse {
  const response =
    data?.instacart_enterprise_frigate_fulfillment_v1_RetailerProductDetailsService_GetRetailerProductDetails

  return {
    products: response?.products ?? [],
  }
}

export const useGetRetailerProductDetails = (): LazyResponse<
  RetailerProductDetailsResponse,
  GetRetailerProductDetailsQueryVariables
> => {
  const resultTuple = useGetRetailerProductDetailsLazyQuery({
    fetchPolicy: 'network-only',
    refetchWritePolicy: 'overwrite',
  })
  const requestData = useApolloRequestLazyWrapper({ resultTuple, mapResponse })

  return requestData
}
